module.exports = __webpack_public_path__ + "img/complete.bea2ed9c.svg";